export const SECTION_PADDING_X = 20;
export const SKELETON_CARD_HEIGHT = 122;
export const TABLET_GRID_GAP = 20;
export const MOBILE_GRID_GAP = 12;
export const TABLET_GRID_ROW_GAP = 16;
export const MOBILE_GRID_ROW_GAP = 8;

export const BOTTOM_BORDER_EDGE_WIDTH = 2;
export const BOTTOM_BORDER_TIP_WIDTH = 0;
export const BOTTOM_BORDER_STEPS = 14;
